import { Modal, notification } from "antd";
import React from "react";
import { Button } from "../Button";
import CopyBlackIcon from "../../icons/copy-icon-black.svg";
import DownloadBlackIcon from "../../icons/download-black.svg";
import { copyToClipboard, downloadBackupCodes } from "../../utils";
import { useMediaQuery } from "react-responsive";
import { DESKTOP_WIDTH } from "@bundles/consts";

type TwoFABackupModalProps = {
  open?: boolean;
  onClose?: () => void;
  backupCodes?: string[];
};

export const TwoFABackupModal = ({
  open,
  onClose,
  backupCodes,
}: TwoFABackupModalProps) => {
  const isMobile = useMediaQuery({ maxWidth: DESKTOP_WIDTH });

  const handleCopyBackupCodes = () => {
    copyToClipboard({
      text: backupCodes.join(", "),
      successMessage: "Backup codes copied to clipboard",
      errMessage: "Failed to copy backup codes",
    });
  };

  const handleDownlaodBackupCodes = () => {
    downloadBackupCodes(backupCodes);
    notification.success({
      message: "Backup codes downloanded.",
    });
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={isMobile ? "100%" : "70%"}
      className="tailwind-2fa-modal"
    >
      <div className="p-6">
        <div>
          <h2 className="text-xl font-semibold">
            Two factor authentication is On
          </h2>

          <div className="mt-2">
            This is the same process you will need to follow every time you
            login to your account once 2FA is enabled.
          </div>

          <div className="mt-4">
            <div className="font-semibold mb-2">Backup codes for 2FA</div>

            <div>
              If you lose access to your authentication app device, you can use
              one of these backup codes to login to your account. Each code may
              be used only once.
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 mt-8">
            {backupCodes.map((code) => (
              <div className="bg-grey-light text-center rounded-[10px] p-4 text-[16px]">
                {code}
              </div>
            ))}
          </div>

          <Button
            onClick={handleDownlaodBackupCodes}
            className="mt-8 w-full flex items-center gap-2"
          >
            Download <DownloadBlackIcon />
          </Button>

          <Button
            onClick={handleCopyBackupCodes}
            className="mt-2 w-full flex items-center gap-2"
          >
            Copy <CopyBlackIcon />
          </Button>

          <Button isPrimary onClick={onClose} className="mt-[40px] w-full">
            Done
          </Button>
        </div>
      </div>
    </Modal>
  );
};
